import { takeEvery, takeLatest, put, select } from 'redux-saga/effects';
import * as actions from './actions';
import * as types from './types';
import { intervalSelector } from '../base/selectors';
import { aiAlertsMetricsMetaSelector , aiAlertsDimensionMappingSelector } from '@store/common/selectors';
import { autoRequest } from '@api/createRequestStore';
import { getAlertsSummaryData } from '@api/aiAlerts';
import { message } from 'antd';
import * as baseTypes from '../base/types';
import { formatSummaryData } from './helper';
import moment from 'moment';
import { dimensionsListSelectorKeyValue } from '@store/common/dimensionList/selectors';

function* initRequest() {
  yield put(actions.init());
}

export function* fetchAlertsSummary() {
  yield put(actions.setFetching(true));
  const interval = yield select(intervalSelector);
  const { from, to } = interval;
  const payload = { from: moment(from).startOf('day').format(), to };

  try {
    const dimensionListObject = yield select(dimensionsListSelectorKeyValue);
    const dimensionMapping = yield select(aiAlertsDimensionMappingSelector);
    const aiAlertsMetricMeta = yield select(aiAlertsMetricsMetaSelector);
    const response = yield autoRequest(getAlertsSummaryData, types.SCOPE, payload);
    const formatted = formatSummaryData({
      response,
      dimensionListObject,
      dimensionMapping,
      aiAlertsMetricMeta,
    });
    yield put(actions.setSummaryData(formatted));
    yield put(actions.setFetching(false));
    yield put(actions.setError(false));
  } catch (error) {
    const errorMsg = error.message || 'Unknown error!';
    message.error(errorMsg);
    yield put(actions.setError(true));
    yield put(actions.setFetching(false));
  }
}

function* watchInitRequest() {
  yield takeLatest([types.INIT], initRequest);
}

function* watchParamChanges() {
  yield takeEvery([types.FETCH_DATA, baseTypes.SET_INTERVAL], fetchAlertsSummary);
}

export default [watchInitRequest, watchParamChanges];
